"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.progress.complete': 'ukończono',
    'onboarding.progress.steps': 'kroki',
};
